import { useEffect, useRef } from 'react';
import { trackPageView } from 'iclinic-trackings';
import { useSelector } from 'react-redux';

import { getUserInfo } from 'features/onlinePayment/state/config/register/selectors';

export interface UsePageViewTrackingParams {
  category: string;
  name: string;
  appFeature: string;
}

export const usePageViewTracking = (
  params: UsePageViewTrackingParams | null,
) => {
  const called = useRef(false);
  const userData = useSelector(getUserInfo);

  useEffect(() => {
    if (!params || called.current) return;

    const { category, name, appFeature } = params;

    trackPageView(category, name, {
      app_id: 'iclinic_web',
      app_feature: appFeature,
      iclinic_id: Number(userData.profileId),
    }).catch((error) => error);

    called.current = true;
  }, [params, userData]);
};
